import { timecode } from '../lib/mediaReview';

export function FramePosition({frame, total, time, title}: {frame?: number; total?: number; time: number; title?: string}) {
  return <div className="review-frame-position" title={title}>
    <div data-testid="video-frame"><span>Кадр </span><strong>{frame || '—'}</strong><span> / {total || '—'}</span></div>
    <output data-testid="video-time">{timecode(time)}</output>
  </div>;
}
